import Hero from '@/components/Hero';

export const isGeneralFullWidthComponent = (sanityModuleData: any) => {
  switch (sanityModuleData._type) {
    case 'hero': //fullwidth component
      return true;
    default:
      return false;
  }
};

const GeneralFullWidthComponent = (sanityModuleData: any) => {
  switch (sanityModuleData._type) {
    case 'hero': //fullwidth component
      return <Hero {...sanityModuleData}></Hero>;
    default:
      return null;
  }
};

export default GeneralFullWidthComponent;
